<template>
  <div class="order-container">
    <!-- 当审核不通过时，才会出现以下模块 -->
    <div class="reason" v-if="orderList.isAgree === 2">
      <div class="title">
        <span class="refuse">拒绝原因：</span>
        <span>{{ orderList.remark }}</span>
      </div>
      <div class="img">
        <div class="title">重新上传处方和病历图片（共2张）</div>
        <upload-pic @getPrescriptionImg="getPrescriptionImg"></upload-pic>
      </div>
      <div class="new-btn">
        <Button type="primary" @click="commitPic">提交审核</Button>
      </div>
    </div>
    <!-- 配送方式为快递 -->
    <StepNumber :current="stepIndex" align="right" v-if="shippingType === 1">
      <StepSon title="1.待付款"></StepSon>
      <StepSon title="2.待发货"></StepSon>
      <StepSon title="3.待收货"></StepSon>
      <StepSon title="4.待评价"></StepSon>
      <StepSon title="5.已完成"></StepSon>
    </StepNumber>
    <!-- 配送方式为自提 -->
    <StepNumber :current="stepIndex" align="right" v-else>
      <StepSon title="1.待付款"></StepSon>
      <StepSon title="2.待核销"></StepSon>
      <StepSon title="3.待评价"></StepSon>
      <StepSon title="4.已完成"></StepSon>
    </StepNumber>
    <div class="alert-box" v-if="orderList._status && !isPrescription">
      <div>
        <Icon type="checkmark-circled icon-checkmark"></Icon
        >{{ orderList._status._msg }}
      </div>
      <div>{{ orderList._add_time }}</div>
    </div>
    <div class="table-box">
      <Table
        border
        ref="selection"
        :columns="columns"
        :data="shoppingCart"
        size="large"
        @on-row-click="rowClick"
      ></Table>
    </div>
    <div class="prescription-container" v-if="isPrescription">
      <h3>处方图片</h3>
      <div class="imgList">
        <div v-if="orderList.prescription && orderList.prescription.length > 0">
          <div
            class="item"
            v-for="(item, index) of orderList.prescription.slice(0, 2)"
            :key="index"
            @click="scaleImg(index)"
          >
            <img :src="item" />
          </div>
        </div>
        <div v-else class="no-image">
          未上传处方图片
        </div>
      </div>
    </div>
    <div class="order-container">
      <h3>订单详情</h3>
    </div>
    <div class="project-box">
      <div class="left">
        <div>收货地址:</div>
        <div>订单编号:</div>
        <div>下单时间:</div>
        <div>订单类型:</div>
        <div>订单状态:</div>
        <div>支付方式:</div>
      </div>
      <div class="right">
        <div v-if="orderList.shipping_type === 1">
          {{ orderList.user_address }} {{ orderList.real_name }}
          {{ orderList.user_phone }}
        </div>
        <div v-else>
          <template v-if="orderList.system_store">
            {{ orderList.system_store._detailed_address }}
            {{ orderList.system_store.name }} {{ orderList.system_store.phone }}
          </template>
        </div>
        <div>{{ orderList.order_id }}</div>
        <div>{{ orderList.add_time_y }} {{ orderList.add_time_h }}</div>
        <div>{{ orderTypeName }}</div>
        <div>{{ orderList.paid ? "已支付" : "未支付" }}</div>
        <div v-if="orderList._status">{{ orderList._status._payType }}</div>
      </div>
    </div>
    <div
      class="order-container pay-method"
      v-if="stepIndex === 0 && !isPrescription"
    >
      <h3>请选择付款方式</h3>
    </div>
    <div class="pay-container" v-if="stepIndex === 0 && !isPrescription">
      <div class="pay-box" v-if="orderList.isAgree === 1">
        <div
          class="pay-list"
          v-if="orderList._status && orderList._status._type !== 9"
        >
          <div
            class="item"
            :class="payType === 'weixin' ? 'active' : ''"
            @click="changePayType('weixin')"
          >
            <div class="left">
              <img src="../../../assets/pc/images/pay/weixin.png" alt="" />
              微信支付
            </div>
            <div class="right">微信快捷支付</div>
          </div>
          <!-- <div class="item" :class="payType === 'alipay' ? 'active' : ''" @click="changePayType('alipay')">
            <div class="left">
              <img src="/assets/pc/images/pay/alipay.png" alt="">
              支付宝支付
            </div>
            <div class="right">支付宝快捷支付</div>
          </div> -->
          <div
            class="item"
            :class="payType === 'yue' ? 'active' : ''"
            @click="changePayType('yue')"
          >
            <div class="left">
              <img src="../../../assets/pc/images/pay/pay.png" alt="" />
              余额支付
            </div>
            <div class="right">可用余额: {{ nowMoney }}</div>
          </div>
          <div
            class="item"
            :class="payType === 'offline' ? 'active' : ''"
            @click="changePayType('offline')"
          >
            <div class="left">
              <img src="../../../assets/pc/images/pay/offline.png" alt="" />
              线下支付
            </div>
            <div class="right">线下方便支付</div>
          </div>
        </div>
        <p class="allMonkey">
          <span>订单应付总额：</span>
          <span class="money">￥{{ orderList.pay_price }}</span>
        </p>
        <div
          class="pay-btn"
          @click="commitOrder"
          v-if="orderList._status && orderList._status._type !== 9"
        >
          <Button type="error" size="large">立即付款</Button>
        </div>
      </div>
    </div>
    <div class="pay-container" v-else>
      <div class="pay-box">
        <p class="allMonkey">
          <span>订单实付总额：</span>
          <span class="money">
            <Icon type="social-yen"></Icon>{{ orderList.pay_price }}
          </span>
        </p>
      </div>
    </div>
    <Modal v-model="modalImg" title="图片放大">
      <div class="bigImage">
        <img :src="bigImage" />
      </div>
    </Modal>
    <div class="mask" v-if="maskShow">
      <div class="content">
        <div class="title" v-if="payType === 'weixin' || payType === 'alipay'">
          <img src="/assets/pc/images/pay/success.png" alt="" />
          <span class="success">付款二维码生成中</span>
        </div>
        <div class="title" v-else>
          <img src="/assets/pc/images/pay/loading.png" alt="" class="laoding" />
          <span class="success">订单处理中</span>
        </div>
        <div class="time">请稍等...</div>
      </div>
    </div>
  </div>
</template>
<script>
import StepNumber from "@/components/pc/commonTool/Steps/StepNumber";
import StepSon from "@/components/pc/commonTool/Steps/StepSon";
import { orderDetail, payOrder } from "@api/order";
import { getUserInfo, changePrescriptionImage } from "@api/user";
export default {
  name: "OrderDetail",
  components: {
    StepNumber,
    StepSon
  },
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 58,
          align: "center"
        },
        {
          title: "图片",
          key: "img",
          width: 86,
          render: (h, params) => {
            return h("div", [
              h("img", {
                attrs: {
                  src: params.row.img
                }
              })
            ]);
          },
          align: "center"
        },
        {
          title: "标题",
          key: "title",
          align: "center"
        },
        {
          title: "属性",
          width: 198,
          key: "package",
          align: "center"
        },
        {
          title: "数量",
          key: "count",
          width: 68,
          align: "center"
        },
        {
          title: "价格",
          width: 100,
          key: "price",
          align: "center"
        }
      ],
      orderList: {},
      shoppingCart: [],
      orderTypeName: "普通订单",
      payType: "weixin",
      nowMoney: 0,
      uniId: "",
      stepIndex: 0,
      modalImg: false,
      bigImage: "",
      imageList: [],
      maskShow: false,
      isPrescription: true,
      shippingType: 2 // 1为快递，2为自提
    };
  },
  created() {
    this.getOrderInfo();
    getUserInfo().then(res => {
      this.nowMoney = res.data.now_money;
    });
  },
  methods: {
    getOrderInfo() {
      this.uniId = this.$route.params.id;
      orderDetail(this.uniId)
        .then(res => {
          this.orderList = res.data;
          if (res.data._status._type === 9) {
            this.stepIndex = 0;
          } else {
            this.stepIndex = res.data._status._type; // 步骤序号
          }

          this.isPrescription =
            res.data.cartInfo[0].productInfo.is_prescription === 1
              ? true
              : false;

          this.shippingType = res.data.shipping_type;

          res.data.cartInfo.forEach(item => {
            item.img = item.productInfo.image;
            item.title = item.productInfo.store_name;
            if (item.productInfo.attrInfo) {
              item.package = item.productInfo.attrInfo.suk;
            }
            item.count = item.cart_num;
            item.price = item.truePrice;
            this.shoppingCart.push(item);
          });
          if (this.orderList.combination_id > 0) {
            this.orderTypeName = "拼团订单";
          } else if (this.orderList.bargain_id > 0) {
            this.orderTypeName = "砍价订单";
          } else if (this.orderList.seckill_id > 0) {
            this.orderTypeName = "秒杀订单";
          }
        })
        .catch(err => {
          if (err.msg === "订单不存在") {
            this.$router.push({
              path: "/home/myOrder"
            });
          }
        });
    },
    changePayType(type) {
      this.payType = type;
    },
    commitOrder() {
      // 先判断订单时间是否过期了
      const addOrderTime = new Date(this.orderList._add_time); // 订单添加的时间
      const passOrderTimeNum = addOrderTime.setDate(addOrderTime.getDate() + 1); // 订单过期时间的毫秒数
      const nowTimeNum = new Date().getTime();
      if (nowTimeNum > passOrderTimeNum) {
        this.$Modal.warning({
          content: "您的订单已过期，请重新下单"
        });
        return;
      }

      if (this.payType === "alipay") {
        this.$Modal.warning({
          content: "支付宝支付待开通中"
        });
      } else if (this.payType === "weixin") {
        // 微信支付
        this.maskShow = true;
        payOrder(this.uniId, this.payType, "weixinpc")
          .then(res => {
            if (res.status === 200) {
              const img = res.data.result.jsConfig.results.codeUrl;
              const orderId = res.data.result.jsConfig.results.order_id;
              this.$router.push({
                name: "Pay",
                params: { img, orderId }
              });
              this.maskShow = false;
            }
          })
          .catch(err => {
            this.maskShow = false;
            this.$Modal.warning({
              content: err.msg
            });
          });
      } else {
        this.maskShow = true;
        payOrder(this.uniId, this.payType, "weixinh5")
          .then(res => {
            if (res.status === 200) {
              const resData = res.data;
              if (resData.status === "SUCCESS") {
                this.$router.go(0);
                this.maskShow = false;
              }
            }
          })
          .catch(err => {
            this.maskShow = false;
            this.$Modal.warning({
              content: err.msg
            });
          });
      }
    },
    scaleImg(index) {
      this.modalImg = true;
      this.bigImage = this.orderList.prescription_images[index];
    },
    getPrescriptionImg(fileList) {
      this.imageList = fileList;
    },
    commitPic() {
      if (this.imageList.length < 2) {
        this.$Message.error("需提供处方和病历，共2张图片");
        return;
      }
      const params = {
        order_id: this.orderList.order_id,
        imageList: this.imageList
      };
      changePrescriptionImage(params).then(res => {
        if (res.status === 200) {
          this.$Message.success("提交成功");
          this.getOrderInfo();
        }
      });
    },
    rowClick(e) {
      this.$router.push({
        path: "/goodsDetail/" + e.product_id
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.order-container /deep/ .ivu-table-cell
  img
    width 100%
  >div
    padding-top 10px
    padding-bottom 10px

.look-account
  text-align center
  margin-bottom 20px

.alert-box
  background #f3fded
  color #999
  border-radius 4px
  padding 10px 20px
  font-size 12px
  margin-bottom 20px
  margin-top 20px
  opacity 0.9
  div
    &:first-child
      font-size 14px
      font-weight 600
      color #7abd5d
      .icon-checkmark
        margin-right 10px
        font-size 18px
        transform translateY(2px)
    &:last-child
      margin-left 25px

.table-box
  margin-top 20px

.prescription-container
  margin 15px 0
  h3
    margin-bottom 10px
    font-size 14px
  .imgList
    overflow-x auto
    white-space nowrap
    .item
      display inline-block
      width 150px
      height 150px
      margin-right 10px
      img
        width 100%
        height 100%
    .no-image
      text-indent 10px


.order-container
  margin-top 20px
  h3
    font-size 15px
  &.pay-method
    margin-top 20px

.project-box
  background #f8f8f9
  margin-top 10px
  padding 10px 20px
  display flex
  .left
    line-height 30px
    font-size 13px
    font-weight 700
    color #666
    font-family 'Microsoft YaHei'
    margin-right 20px
  .right
    line-height 30px
    font-size 13px
    color #999

.pay-container
  margin 15px 0
  display flex
  justify-content flex-end
  .pay-box
    font-size 18px
    font-weight bolder
    color #495060
    width 100%
    .pay-list
      display flex
      justify-content space-between
      .item
        display flex
        justify-content space-between
        border 1px solid #dedede
        font-size 14px
        font-weight normal
        padding 5px
        margin-bottom 10px
        cursor pointer
        width 32%
        &.active
          border 1px solid #ff7a7a
          animation rainbow 1s ease
        .left
        .right
          width 50%
          text-align: center
        .left
          border-right 1px solid #eee
          img
            width 18px
            height 18px
            position relative
            top 4px
        .right
          color #9b9b9b
    .allMonkey
      margin-top 30px
      text-align right
      font-family 'Microsoft yahei'
      .money
        font-size 26px
        color #f90013

.pay-btn
  margin 15px 0px
  display flex
  justify-content flex-end

.bigImage
  img
    width 100%

.reason
  padding 20px 20px
  border 1px dashed red
  margin-bottom 20px
  .title
    .refuse
      font-size 14px
      font-weight 600
      color #333
  .img
    .title
      font-size 14px
      color #666
      margin 20px 0 5px
  .new-btn
    margin-top 10px

.account-detail
  .item
    margin-bottom 10px
    padding-bottom 10px
    border-bottom 1px dashed rgb(182, 182, 182)
    &:last-child
      border none
      margin 0
      padding 0
    div
      &:first-child
        font-size 14px
        font-weight 550
        color #666
        margin-bottom 5px


.mask
  position fixed
  top: 0
  background rgba(0, 0, 0, .5)
  left 0
  right 0
  bottom 0
  display flex
  align-items center
  justify-content center
  z-index 999
  .content
    width 300px
    height 150px
    background #fff
    padding 30px
    border-radius 8px
    .title
      text-align center
      .laoding
        animation:turn 2s linear infinite
      img
        width 24px
        height 24px
        display inline-block
        position relative
        top 6px
      .success
        font-size 18px
        margin-left 5px
  .time
    margin-top 25px
    text-align center
    font-size 14px

@keyframes turn
  0%
    -webkit-transform rotate(0deg)
  25%
    -webkit-transform rotate(90deg)
  50%
    -webkit-transform rotate(180deg)
  75%
    -webkit-transform rotate(270deg)
  100%
    -webkit-transform rotate(360deg)
@keyframes rainbow
  50%
    transform: scale(1.1)

  100%
    transform scale(1)
</style>
